// icons/WarningCircleIcon.jsx

const WarningCircleIcon = ({
  size = 72,
  bgColor = "#FFF1F1",
  stroke = "#FF4D4F"
}) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "9999px",
        background: bgColor,

        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        flexShrink: 0
      }}
    >
      <svg
        width={80}
        height={58}
        viewBox="0 0 24 24"
        fill="none"
      >
        {/* outer circle */}

        <circle
          cx="12"
          cy="12"
          r="8"
          stroke={stroke}
          strokeWidth="2"
        />

        {/* exclamation line */}

        <path
          d="M12 7V12"
          stroke={stroke}
          strokeWidth="2"
          strokeLinecap="round"
        />

        {/* dot */}

        <circle
          cx="12"
          cy="16"
          r="1.2"
          fill={stroke}
        />
      </svg>
    </div>
  );
};

export default WarningCircleIcon;